import type { GuestRequestType } from "./GuestRequestFlow";

export function GuestActionIcon({type}:{type:GuestRequestType}){
  if(type==="APPOINTMENT")return <svg viewBox="0 0 32 32" aria-hidden="true"><rect x="5" y="7" width="22" height="20" rx="3"/><path d="M10 4v6m12-6v6M5 13h22m-16 6 3 3 7-7"/></svg>;
  if(type==="QUOTE")return <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M8 4h13l5 5v19H8z"/><path d="M21 4v6h5M12 15h10m-10 5h7m-7 4h5"/></svg>;
  if(type==="EV_CHECK")return <svg viewBox="0 0 32 32" aria-hidden="true"><rect x="4" y="9" width="21" height="15" rx="3"/><path d="M25 14h3v5h-3M9 16h4l2-4 3 8 2-4h3"/></svg>;
  return <svg viewBox="0 0 32 32" aria-hidden="true"><path d="M20 5a7 7 0 0 0-8.5 8.5L5 20l7 7 6.5-6.5A7 7 0 0 0 27 12l-5 5-5-2-2-5z"/></svg>;
}
